import { useEffect, useState } from "react";
import { useGetPatientSyncStatusQuery } from "../service/patientSync.service";
import { useAppSelector } from "./redux-hooks";

/** A pull is a real EHR login, so nothing changes on a sub-minute timescale. */
const POLL_MS = 30000;

/** Whether this clinician's patient list is still being fetched from their EHR. */
export default function usePatientSync() {
  const isRpaGroup = Boolean(useAppSelector((state) => state.auth.userInfo.group_rpa_enabled));
  const [pollingInterval, setPollingInterval] = useState(POLL_MS);
  const { data } = useGetPatientSyncStatusQuery(undefined, { skip: !isRpaGroup, pollingInterval });
  // Poll only while a pull is outstanding; 0 stops the poll.
  useEffect(() => {
    if (data) setPollingInterval(data.state === "syncing" ? POLL_MS : 0);
  }, [data]);
  return { isSyncing: data?.state === "syncing" };
}
